import { NavLink, useLocation } from "react-router-dom";
import { Home, ListChecks, BarChart3, Crown, LayoutDashboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useConfig } from "@/hooks/useConfig";

export function MobileNav() {
  const { isVip, isMember } = useAuth();
  const { config } = useConfig();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const vipUrl = config?.whop?.vip_checkout_url || "/#pricing";
  const items = [
    { to: "/", label: "Home", icon: Home, testid: "mnav-home", end: true },
    { to: "/picks", label: "Picks", icon: ListChecks, testid: "mnav-picks" },
    { to: "/results", label: "Results", icon: BarChart3, testid: "mnav-results" },
    isVip || isMember
      ? { to: "/dashboard", label: isVip ? "VIP" : "Account", icon: isVip ? Crown : LayoutDashboard, testid: "mnav-dashboard" }
      : { href: vipUrl, label: "Join VIP", icon: Crown, testid: "mnav-vip", accent: true },
  ];
  const base = "flex min-h-[56px] flex-1 flex-col items-center justify-center gap-1 font-display text-[11px] font-bold uppercase tracking-wider transition-colors";
  return (
    <nav className="mobile-nav fixed inset-x-0 bottom-0 z-40 border-t border-[#1E2738] bg-[#0B0E14]/95 backdrop-blur-md md:hidden" aria-label="Mobile primary" data-testid="mobile-bottom-nav">
      <div className="flex">
        {items.map((it) => {
          const Icon = it.icon;
          if (it.href) {
            return (
              <a key={it.label} href={it.href} target={it.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid={it.testid} className={`${base} text-[#00E676]`}>
                <Icon size={20} aria-hidden="true" /> {it.label}
              </a>
            );
          }
          return (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.testid} aria-label={it.label}
              className={({ isActive }) => `${base} ${isActive ? "text-[#00E676]" : "text-slate-400"}`}>
              {({ isActive }) => (
                <>
                  <span className={`absolute top-0 h-0.5 w-10 rounded-b bg-[#00E676] transition-opacity ${isActive ? "opacity-100" : "opacity-0"}`} />
                  <Icon size={20} aria-hidden="true" /> {it.label}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}

export default MobileNav;
